package org.lennycodes.hldi.backend.db_service

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.sendPasswordResetEmail

suspend fun sendResetPassword(email: String): Boolean {

    return try {

        sendPasswordResetEmail(
            FirebaseService.auth,
            email
        ).await()

        true

    } catch (e: Throwable) {

        console.error(
            "Reset password error: ${e.message}"
        )

        false
    }
}